import React, { Component } from "react";
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as customerActions from '../Actions/customerActions';
import * as tmxActions from '../Actions/tmxActions';
import * as userActions from '../Actions/userActions';
import * as languageActions from '../Actions/languageActions';
import * as supplierConfigurationActions from '../Actions/supplierConfigurationActions';
import CustomerForm from "../Components/Customer/CustomerForm";
import UserList from "../Components/User/UserList";
import { customerService } from "../Services/CustomerService.js";
import { tmxService } from "../Services/TmxService.js";
import { userService } from "../Services/UserService.js";
import { withRouter } from 'react-router';
import Grid from '@material-ui/core/Grid';
import { Link } from 'react-router-dom';
import Button from '@material-ui/core/Button';
import {searchFilterService} from "../Services/SearchFilterService.js";
import { normalize } from 'normalizr';
import { customerSchema, userSchema } from '../Schemas/OrderSchema.js';
import {denormalizerService} from "../Services/denormalizerService.js";

class CustomerFormContainer extends Component {
	constructor(props){
		super(props);
		this.state={
			processing: false,
			glosaris: [],
		};
		this.handleMorePriority=this.handleMorePriority.bind(this);
		this.fetchCustomerRecords = this.fetchCustomerRecords.bind(this);
		this.handleChangConfig = this.handleChangConfig.bind(this);
		this.setParallelTextPdf = this.setParallelTextPdf.bind(this);
		this.setIgnoreMatch100 = this.setIgnoreMatch100.bind(this);
		this.setGaleradaComptaParaules = this.setGaleradaComptaParaules.bind(this);
		this.switchUserState = this.switchUserState.bind(this);
		this.setSharedUsersView = this.setSharedUsersView.bind(this);
		this.handleUploadDocument = this.handleUploadDocument.bind(this);
		this.handleRemoveDocument = this.handleRemoveDocument.bind(this);
		this.addSupplierConfig = this.addSupplierConfig.bind(this);
	}

	componentDidMount() {
		tmxService.listTmx()
					.then(response => {return this.props.actions.tmxActions.fetchTmxRecords(response.data);})
					.then(response => {return customerService.listCustomers()})
					.then(response => {return this.fetchCustomerRecords(response.data);})
					.then(response => {return userService.listUsers()})
					.then(response => {return this.fetchUserRecords(response.data);})
					.then(response => {return customerService.listGlosaris(this.props.customer.id);})
					.then(response => this.setState({glosaris: response.data}))
					.catch(err => {/*console.log(err);*/});
	}
	
	fetchCustomerRecords(responseData){
		var normalizedData = normalize(responseData, [customerSchema]);
		this.props.actions.customerActions.fetchCustomerRecords(normalizedData.entities.customers);
		this.props.actions.supplierConfigActions.fetchSupplierConfigurationRecords(normalizedData.entities.supplierConfiguration);
//		this.props.actions.userActions.fetchUserRecords(normalizedData.entities.user);
		this.props.actions.languageActions.fetchLanguagePairs(normalizedData.entities.languagePairs);
		return 1;
	}
	
	fetchUserRecords(responseData){
		var normalizedData = normalize(responseData, [userSchema]);
		this.props.actions.userActions.fetchUserRecords(normalizedData.entities.users);
		return 1;
	}

//	handleMorePriority(idProd, index, idUsr){
	handleMorePriority(idProd, index, idSupplierConfig){
//		console.log("CustomerFormContainer.handleMorePriority(idProd:"+idProd+", index:"+index+", idConfig:"+idSupplierConfig+")");
//		console.log(this.props.supplierConfigRecords);
//		console.log(this.props.customer.product);
		if(index>0){
			let supplier_config_ids = this.props.customer.product.find(prod => {if(prod.id == idProd){return true;}}).suppliers;
			console.log("supplier_config");
			console.log(supplier_config_ids);
			let enabled = supplier_config_ids.filter( s => this.props.userRecords[this.props.supplierConfigRecords[s].supplier].enabled );
			let disabled = supplier_config_ids.filter( s => !this.props.userRecords[this.props.supplierConfigRecords[s].supplier].enabled );
			let users=[];
			let supplierConfigs=[];
//			console.log(enabled);
			for(let i=0; i<enabled.length; i++){
//				console.log(i);
				if(i==(index-1)){
					supplierConfigs.push(enabled[index]);
					supplierConfigs.push(enabled[i]);
					i++;
				}else{
					supplierConfigs.push(enabled[i]);
				}
//				console.log(supplierConfigs);
			}
			supplierConfigs.push(...disabled);
//			console.log("handleMorePriority users: "+JSON.stringify(supplierConfigs));
			customerService.updateSupplierList(this.props.customer.id, idProd, supplierConfigs)
					.then(response => {return customerService.listCustomers()})
					.then(response => {return this.fetchCustomerRecords(response.data);})
					.catch(err => {/*console.log(err);*/});
		}
	}
	
	handleChangConfig(idProd, configValue){
//		console.log("CustomerFormContainer.handleChangConfig(idProd:"+idProd+", configValue:"+configValue+")");
		customerService.updateWfConfig(this.props.customer.id, idProd, configValue)
					.then(response => {return customerService.listCustomers()})
					.then(response => {return this.fetchCustomerRecords(response.data);})
					.catch(err => {/*console.log(err);*/});
	}
	
	addSupplierConfig(idProd, idUser, idTranslator){
		customerService.addWfConfig(this.props.customer.id, idProd, idUser, idTranslator)
					.then(response => {return customerService.listCustomers()})
					.then(response => {return this.fetchCustomerRecords(response.data);})
					.catch(err => {/*console.log(err);*/});
	}
	
	setParallelTextPdf(checked){
		customerService.setParallelTextPdf(this.props.customer.id, checked)
					.then(response => {return customerService.listCustomers()})
					.then(response => {return this.fetchCustomerRecords(response.data);})
					.catch(err => {/*console.log(err);*/});
	}
	setIgnoreMatch100(checked){
		customerService.setIgnoreMatch100(this.props.customer.id, checked)
					.then(response => {return customerService.listCustomers()})
					.then(response => {return this.fetchCustomerRecords(response.data);})
					.catch(err => {/*console.log(err);*/});
	}
	setGaleradaComptaParaules(checked){
		customerService.setGaleradaComptaParaules(this.props.customer.id, checked)
					.then(response => {return customerService.listCustomers()})
					.then(response => {return this.fetchCustomerRecords(response.data);})
					.catch(err => {/*console.log(err);*/});
	}
	
	switchUserState(user, newState){
		user.enabled=newState;
		let denormlaizedUser = denormalizerService.userDenormalizer(user);
		userService.updateUser(denormlaizedUser)
					.then(response => userService.listUsers())
					.then(response => this.fetchUserRecords(response.data))
//					.then(response => {return this.props.history.go(0);})
					.catch(err => {/*console.log(err);*/});
	}
	
	setSharedUsersView(id, userList){
		userService.setSharedUsersView(id, userList)
					.then(response => userService.listUsers())
					.then(response => this.fetchUserRecords(response.data))
					.catch(err => {/*console.log(err);*/});;
	}
	
	handleUploadDocument(custId, file){
		this.setState({processing: true})
		return customerService.uploadDocument(custId, file)
			.then(response => {return customerService.listCustomers()})
			.then(response => {return this.fetchCustomerRecords(response.data);})
			.then (r => {return this.setState({processing: false})})
			.catch(err => {/*console.log(err);*/});
	}
	
	handleRemoveDocument(custId, docId){
		this.setState({processing: true})
		return customerService.removeDocument(custId, docId)
			.then(response => {return customerService.listCustomers()})
			.then(response => {return this.fetchCustomerRecords(response.data);})
			.then (r => {return this.setState({processing: false})})
			.catch(err => {/*console.log(err);*/});
	}
	
	render() {
		//console.log("[CustomerFormContainer.render()]");
		//console.log(this.props);
	    return (<div class="contentM"><Grid container item direction="column" alignItems="center" justify="center" spacing={2}>
					<Grid container item direction="row" alignItems="center" justify="center" spacing={0}>
						<Grid item xs={12}>
							<CustomerForm	customer={this.props.customer}
											tmxRecords={this.props.tmxRecords}
											users={this.props.userRecords}
											langPairs={this.props.langPairs}
											supplierConfig={this.props.supplierConfigRecords}
//											customerActions={this.customerActions}
											morePriority={this.handleMorePriority}
											changConfig={this.handleChangConfig}
											setParallelTextPdf={this.setParallelTextPdf}
											setIgnoreMatch100={this.setIgnoreMatch100}
											setGaleradaComptaParaules={this.setGaleradaComptaParaules}
											glosaris={this.state.glosaris}
											processing = {this.state.processing}
											handleDocument={this.handleUploadDocument}
											handleRemoveDocument={this.handleRemoveDocument}
											addSupplierConfig = {this.addSupplierConfig}
											accessToken={this.props.user.access_token}/>
						</Grid>
					</Grid>
					<Grid container item direction="row" alignItems="center" justify="flex-start" spacing={0}>
						<Grid item xs={2}>
							<h2>Users:</h2>
						</Grid>
						<Grid item xs={10}>
							<Button variant="contained" color="primary" aria-label="New User">
								<Link style={{textDecoration: 'none'}} to={`/userForm/0/`+this.props.customer.id}>NEW</Link>
							</Button>
						</Grid>
					</Grid>
					<Grid container item direction="row" alignItems="center" justify="center" spacing={0}>
						<Grid item xs={12}>
							<UserList	customers = {Array.of(this.props.customer)}
										users={this.props.customerUsers}
										relatedUsers={this.props.customerUsers}
										userActions={this.userAction}
										switchUserState = {this.switchUserState}
										setSharedUsersView = {this.setSharedUsersView}
							/>
						</Grid>
					</Grid>
				</Grid></div>
				);
	}
}

function mapStateToProps(state, ownProps) {
	return {customer: state.customers[ownProps.match.params.id],
			supplierConfigRecords: state.supplierConfiguration,
//			tmxRecords: state.tmxs.filter(tmx => {	if((tmx.customers) && (tmx.customers[0]) && (tmx.customers[0].id == ownProps.match.params.id)){ return true;}
//													else{return false;}}),
			tmxRecords: state.tmxs.filter(tmx => { if(tmx.customers && tmx.customers.length>0){
														return tmx.customers.reduce((found, cust) => {
															if(cust.id == ownProps.match.params.id){
																return found+1;
															}else{ return found;}
														}, 0 )>0;
													}else {return false;}
												}),
//			tmxRecords: searchFilterService.objectFilter(state.tmxs, (tmx => {	if((tmx.customers) && (tmx.customers[0]) && (tmx.customers[0].id == ownProps.match.params.id)){
//																										return true;}
//																									else{return false;}})),
			customerUsers: searchFilterService.objectFilter(state.users, (user => {return (user.role=='CUSTOMER' && user.customer!== undefined && user.customer == ownProps.match.params.id);})),
			userRecords: state.users,
			langPairs: state.languagePairs,
			user: state.user}
}

function mapDispatchToProps(dispatch) {
	//return {actions: bindActionCreators(Object.assign({}, userActions, customerActions, languageActions, tmxActions), dispatch)}
	return {
		actions: {
			customerActions: bindActionCreators(customerActions, dispatch),
			supplierConfigActions: bindActionCreators(supplierConfigurationActions, dispatch),
			tmxActions: bindActionCreators(tmxActions, dispatch),
			languageActions: bindActionCreators(languageActions, dispatch),
			userActions: bindActionCreators(userActions, dispatch)
		}
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(CustomerFormContainer);  